// extracted by mini-css-extract-plugin
module.exports = {"proSection":"ProSection_proSection__08_bi","cards":"ProSection_cards__yvskp","card":"ProSection_card__RtXUl","icon":"ProSection_icon__lFpso","image":"ProSection_image__RWKxZ"};